import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/paymentInfo",
    name: "PaymentInfo",
    component: () => import("../views/PaymentInfo.vue"),
  },
  {
    path: "/clearCache",
    name: "clearCache",
    beforeEnter: (to, from, next) => {
      store.commit("resetState");
      return next({ name: "Home" });
    },
  },
  {
    path: "/loyalty",
    name: "Loyalty",
    component: () => import("../views/loyaltyProgram.vue"),
  },
  {
    path: "/requisites",
    name: "Requisites",
    component: () => import("../views/Requisites.vue"),
  },
  {
    path: "/franchise",
    name: "Franchise",
    component: () => import("../views/Franchise.vue"),
  },
  {
    path: "/localmenu",
    name: "LocalMenu",
    component: () => import("../views/LocalMenu.vue"),
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("../views/Privacy.vue"),
  },
  {
    path: "/menu/:groupId",
    name: "Menu",
    component: () => import("../views/Menu.vue"),
  },
  {
    path: "/howto/:groupId",
    name: "howTo",
    component: () => import("../views/HowToCook.vue"),
  },
  {
    path: "/post/:postId",
    name: "PostPage",
    component: () => import("../views/PostPage.vue"),
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("../views/NotFound.vue"),
  },
  // { path: "*", redirect: { name: "Home" } },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from) {
    if (from.path !== to.path) {
      return { x: 0, y: 0 };
    }
  },
});

import * as metaData from "./meta.json";
const allMeta = metaData.default;
const defaultMeta = {
  title:
    "Доставка сети ресторанов Пельмения в СПб: пельмени народов мира - 38 видов",
  description:
    "Культ пельменей - 38 видов пельменей мира ручной лепки. Доставка готовых блюд и заморозки. Бонусная система (cash back) и более 20 000 довольных клиентов.",
};
router.beforeEach((to, from, next) => {
  let metaForPage = allMeta.filter((meta) => to.path.includes(meta.route));
  let description = document.querySelector('head meta[name="description"]');
  if (metaForPage.length > 0) {
    let lastMeta = metaForPage[metaForPage.length - 1];
    document.title = lastMeta.title;
    description.setAttribute("content", lastMeta.description);
  } else {
    document.title = defaultMeta.title;
    description.setAttribute("content", defaultMeta.description);
  }
  next();
});

export default router;
